var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-table-empty"},[_c('AppImage',{staticClass:"empty-image",attrs:{"src":require('@/assets/img/empty-table.png'),"title":_vm.$t('no_data')}}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }